import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';

import styles from 'src/components/layout/landlord/NavigationLink.module.css';

type Props = {
    text?: React.ReactNode;
    icon?: React.ReactNode;
    link?: string;
    onClick: () => void;
};

export default function NavigationLink({
    text,
    icon,
    link,
    onClick,
}: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const isSelected = !!link && location.pathname.includes(link);
    const bgcolor = isSelected ? 'primary.50' : 'invalid';
    const color = isSelected ? '#0C8C62' : '#615F57';

    const handleClick = () => {
        onClick();

        if (link) {
            navigate(link);
        }
    };

    return (
        <>
            <ListItem disablePadding data-testid={`${text}-link`}>
                <ListItemButton className={styles.button} onClick={handleClick} sx={{ bgcolor }}>
                    {!!icon && <ListItemIcon sx={{ color, minWidth: 0, marginRight: 1 }}>{icon}</ListItemIcon>}
                    {!!text && <Typography fontWeight={400} fontSize={14} color={color} component="span" className="ellipsisText">{text}</Typography>}
                </ListItemButton>
            </ListItem>
        </>
    );
}
